import React from 'react';

export default class Puff extends React.PureComponent {
    static propTypes = {};
    render() {
        return (
            <div className="puffContainer">
                <div className="puff legs" />
                <div className="puff body" />
                <div className="puff leftWing" />
                <div className="puff rightWing" />
                <div className="puff head" />
            </div>
        );
    }
}

